module.exports = "/src/views/player/hudevo/phonenew/assets/images/mech.png";